'use client';

import Link from 'next/link';
import { SiteLogo } from './site-logo';

interface FooterProps {
  icpBeian?: string;
  gonganBeian?: string;
  gonganBeianCode?: string;
  companyName?: string;
}

export function Footer({
  icpBeian = '粤ICP备2026035663号-1',
  gonganBeian = '粤公网安备44011302005393号',
  gonganBeianCode = '44011302005393',
  companyName = 'AI组织进化',
}: FooterProps) {
  return (
    <footer className="relative z-10 border-t border-white/5 bg-[#0a0a0f]/80 backdrop-blur-xl">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
        {/* 主要内容 */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* 品牌 */}
          <div className="md:col-span-1">
            <SiteLogo />
            <p className="mt-4 text-sm text-gray-500">
              AI时代组织效率提升指南<br />
              助力企业在AI浪潮中找准方向
            </p>
          </div>

          {/* 栏目导航 */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-4">栏目</h3>
            <ul className="space-y-2">
              <li>
                <Link href="/category/unchanged" className="text-sm text-gray-500 hover:text-cyan-400 transition-colors">
                  不变的本质
                </Link>
              </li>
              <li>
                <Link href="/category/disrupted" className="text-sm text-gray-500 hover:text-orange-400 transition-colors">
                  颠覆的机会
                </Link>
              </li>
              <li>
                <Link href="/category/disappeared" className="text-sm text-gray-500 hover:text-red-400 transition-colors">
                  消失的岗位
                </Link>
              </li>
              <li>
                <Link href="/category/emerging" className="text-sm text-gray-500 hover:text-emerald-400 transition-colors">
                  新增的能力
                </Link>
              </li>
            </ul>
          </div>

          {/* 内容导航 */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-4">内容</h3>
            <ul className="space-y-2">
              <li>
                <Link href="/articles" className="text-sm text-gray-500 hover:text-cyan-400 transition-colors">
                  热门洞察
                </Link>
              </li>
              <li>
                <Link href="/courses" className="text-sm text-gray-500 hover:text-orange-400 transition-colors">
                  行动工具
                </Link>
              </li>
              <li>
                <Link href="/agents" className="text-sm text-gray-500 hover:text-purple-400 transition-colors">
                  AI智能体
                </Link>
              </li>
            </ul>
          </div>

          {/* 入群讨论 */}
          <div className="text-center">
            <h3 className="text-sm font-semibold text-white mb-4">入群讨论</h3>
            <img 
              src="/wechat-qr.jpg" 
              alt="入群讨论二维码" 
              className="w-32 h-32 mx-auto rounded-lg"
            />
            <p className="mt-2 text-xs text-gray-500">算法组织实验室</p>
          </div>
        </div>

        {/* 分割线 */}
        <div className="border-t border-white/5 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            {/* 版权信息 */}
            <p className="text-sm text-gray-600">
              © {new Date().getFullYear()} {companyName} · 版权所有
            </p>

            {/* 备案信息 */}
            <div className="flex flex-col md:flex-row items-center gap-4 text-sm text-gray-500">
              {/* ICP备案 */}
              <a
                href="https://beian.miit.gov.cn/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-gray-400 transition-colors"
              >
                {icpBeian}
              </a>

              {/* 公安备案 */}
              <a
                href={`http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${gonganBeianCode}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-gray-400 transition-colors"
              >
                <svg className="h-4 w-4 flex-shrink-0 text-gray-500" viewBox="0 0 14 16" fill="currentColor">
                  <path d="M7 0L0 3v4c0 4.42 2.97 8.56 7 9.6 4.03-1.04 7-5.18 7-9.6V3L7 0zm0 1.29l5.5 2.36v3.35c0 3.64-2.47 7.07-5.5 8.07-3.03-1-5.5-4.43-5.5-8.07V3.65L7 1.29z"/>
                  <path d="M6.5 7.8L5.1 6.4 4.3 7.2l2.2 2.2 4.2-4.2-.8-.8-3.4 3.4z"/>
                </svg>
                <span>{gonganBeian}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
